<template>
  <div>

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <label class="title">量表结论统计</label>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"

        size="middle"
        rowKey="resultid"
        :columns="columns"
        :dataSource="dataSource"
        :scroll="{x:'150',y:'calc(100vh - 350px)'}"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">
      </a-table>
    </div>

  </div>
</template>

<script>
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  export default {
    name: "VerdictTable",
    mixins: [JeecgListMixin],
    components: {

    },
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        queryParam: {},
        centerName:'',
        columns: [],
        url: {
          list: "/project/statistic/verdict/info",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    mounted(){
      this.queryParam.projectId = this.projectId
      // this.queryParam.useCache = false
      this.loadDataPeriod()
      this.loadData()
    },
    watch:{
    },
    methods: {
      loadDataPeriod(){
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            const columns = [
              {
                title: '量表',
                align: "center",
                fixed:'left',
                dataIndex: 'formname',
                width: 150,
                customRender: (value, row, index) => {
                  const lastrow = index===0?{}:this.dataSource[index-1]
                  const obj = {
                    children: value,
                    attrs: {},
                  };
                  if (lastrow.formid === row.formid) {
                    obj.attrs.rowSpan = 0;
                  }else{
                    let rowSpan = 1;
                    let end = false
                    this.dataSource.forEach((baserow,baseIndex)=>{
                      if(baseIndex>index && !end){
                        if (baserow.formid === row.formid) {
                          rowSpan++;
                        }else{
                          end = true
                        }
                      }
                    })
                    obj.attrs.rowSpan = rowSpan;
                  }
                  return obj;
                },
              },
              {
                title: '维度',
                align: "center",
                fixed:'left',
                width: 200,
                dataIndex: 'formitemname',
                customRender: (value, row, index) => {
                  const lastrow = index===0?{}:this.dataSource[index-1]
                  const obj = {
                    children: value,
                    attrs: {},
                  };
                  if (lastrow.formid === row.formid && lastrow.formitemid === row.formitemid) {
                    obj.attrs.rowSpan = 0;
                  }else{
                    let rowSpan = 1;
                    let end = false
                    this.dataSource.forEach((baserow,baseIndex)=>{
                      if(baseIndex>index && !end){
                        if (baserow.formid === row.formid && baserow.formitemid === row.formitemid) {
                          rowSpan++;
                        }else{
                          end = true
                        }
                      }
                    })
                    obj.attrs.rowSpan = rowSpan;
                  }
                  return obj;
                },
              },
              {
                title: '结论',
                align: "center",
                fixed:'left',
                width: 200,
                dataIndex: 'result',
                customRender: (value, row, index) => {
                  value = value || '-'
                  return value
                },
              }
            ]
            res.result.forEach(item=>{
              const parentColumn = {
                title: item.name,
                align: "center",
                children:[]
              }
              parentColumn.children.push({
                title: '提交人次',
                align: "center",
                width: 100,
                dataIndex: 'formcount'+item.id,
                customRender: (value, row, index) => {
                  if(value==undefined || value == null && value == ''){
                    value =  '/'
                    const lastrow = index===0?{}:this.dataSource[index-1]
                    const obj = {
                      children: value,
                      attrs: {colSpan:2},
                    };
                    if (lastrow.formid === row.formid && lastrow.formitemid === row.formitemid) {
                      obj.attrs.rowSpan = 0;
                    }else{
                      let rowSpan = 1;
                      let end = false
                      this.dataSource.forEach((baserow,baseIndex)=>{
                        if(baseIndex>index && !end){
                          if (baserow.formid === row.formid && baserow.formitemid === row.formitemid) {
                            rowSpan++;
                          }else{
                            end = true
                          }
                        }
                      })
                      obj.attrs.rowSpan = rowSpan;
                    }
                    return obj;
                  }else{
                    const lastrow = index===0?{}:this.dataSource[index-1]
                    const obj = {
                      children: value,
                      attrs: {},
                    };
                    if (lastrow.formid === row.formid && lastrow.formitemid === row.formitemid && (lastrow['formcount'+item.id] === row['formcount'+item.id])) {
                      obj.attrs.rowSpan = 0;
                    }else{
                      let rowSpan = 1;
                      let end = false
                      this.dataSource.forEach((baserow,baseIndex)=>{
                        if(baseIndex>index && !end){
                          if (baserow.formid === row.formid && baserow.formitemid === row.formitemid && baserow['formcount'+item.id] === row['formcount'+item.id]) {
                            rowSpan++;
                          }else{
                            end = true
                          }
                        }
                      })
                      obj.attrs.rowSpan = rowSpan;
                    }
                    return obj;
                  }

                },
              })
              parentColumn.children.push({
                title: '对应人次（占比）',
                align: "center",
                width: 150,
                dataIndex: 'count'+item.id,
                customRender: (value, row, index) => {
                  if(value==undefined || value == null && value == ''){
                    return {
                      children: value,
                      attrs: {colSpan:0},
                    }
                  }
                  return `${value}(${row['rate'+item.id] || 0}%)`
                },
              })
              columns.push(parentColumn)
            })
            this.columns = columns
          }
        })
      },
      loadDataCallback(){}
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>